export const errorMsg = (type: string, length: number): string =>
  `Please enter ${type === "min" ? "at least" : ""} ${length} characters${
    type === "max" ? " or less" : ""
  }.`;
